<!-- 库存属性调整操作 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                       @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <el-table size="mini" ref="mxTableRef" id="mxTable" :data="tableData" border style="width: 100%" :height="mxHeight">
                                 <el-table-column align="center" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in mxForm"
                                                  :key="formOneKey">
                                    <template slot-scope="scope">
                                       <span v-if="formOneValue.fieldType == 'date'">
                                          <span v-if="scope.row[formOneValue.entityField]">
                                             {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <span v-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(scope.row[formOneValue.riftField])">{{ scope.row[formOneValue.entityField] }}</a>
                                       </span>
                                       <span
                                             v-else-if="formOneValue.fieldType == 'formatter'">{{getValue(scope.row[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}</span>
                                       <span v-else>
                                          {{ scope.row[formOneValue.entityField] }}
                                       </span>
                                    </template>
                                 </el-table-column>

                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
         </div>
      </div>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "inventoryPackagingAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      // ExtractionScheme,
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         showTabs: "",
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         tableData: [],
         formDataList: [],
         mxHeight: 0,
         tabForm: [
            {
               isShowForm: 0,
               jciName: "查看信息",
            }
         ],
         mxForm: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'smIntype') {
            this.dictionariesDatas.forEach(item => {
               if (item.diValue == val) {
                  str = item.diName
               }
            })
         } else if (fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      // 打印方法
      showPrintPlan() {
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 父级传入
      openBox() {
         console.log(this.actionData);

         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData
         this.tableData = this.actionData.oldData
         this.filterMainField()
         this.showTabs = "查看信息"
         this.dataActionBox.boxTitle = '查看信息'
         this.$nextTick(() => {
            setTimeout(() => {
               this.mxHeight = this.$common.getHeight()
            }, 16.7)
         })
      },
      // 过滤表单不同类型
      filterMainField() {
         this.formDataList.forEach(item => {
            if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
      }
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>